import React from 'react';

const escape = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
export const MentionText = ({ text, mentions, currentUserId, onProfile, prefix }) => {
  if (!mentions?.length) return text;
  const names = [...mentions].sort((a, b) => b.username.length - a.username.length);
  const pattern = new RegExp(`(^|[^\\p{L}\\p{N}_@])@(${names.map((item) => escape(item.username)).join('|')})(?=$|[^\\p{L}\\p{N}_])`, 'giu');
  const parts = []; let cursor = 0;
  for (const match of text.matchAll(pattern)) {
    const start = match.index + match[1].length, end = match.index + match[0].length;
    const person = names.find((item) => item.username.toLowerCase() === match[2].toLowerCase());
    parts.push(text.slice(cursor, start));
    parts.push(<button type="button" key={start} className={`chat-mention-link${person.user_id === currentUserId ? ' is-self' : ''}`} data-testid={`${prefix}-mention-${start}`} aria-label={`View ${person.username}'s profile`} onClick={(event) => onProfile(person.user_id, event.currentTarget)}>{text.slice(start, end)}</button>);
    cursor = end;
  }
  parts.push(text.slice(cursor));
  return <>{parts}</>;
};